import { filter as adfFilter } from '@atlaskit/adf-utils/filter';
import type { DocNode } from '@atlaskit/adf-schema/doc';

export const getEmojis = (content: DocNode) => {
	return adfFilter(content, (node) => node.type === 'emoji');
};
